import { render, staticRenderFns } from "./application-notes-table.vue?vue&type=template&id=888a14b4"
import script from "./application-notes-table.vue?vue&type=script&lang=js"
export * from "./application-notes-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports